import axios from 'axios';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resetState, setSession } from 'store/auth';

const BASE_URL = process.env.REACT_APP_API_URL;

// This is needed as default API instance takes token from redux store and it shouldn't be set before checking the validity of the token.
const api = axios.create({
  baseURL: BASE_URL,
});

const useVerifyWithTokenAndRedirect = (token: string, redirectUri: string) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (!token) return;

      try {
        const res = await api.get('/user/verify', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res?.data) {
          throw new Error('Invalid token');
        }

        dispatch(setSession({ token, user: res?.data }));
        navigate(redirectUri, { replace: true });
      } catch {
        dispatch(resetState());
        navigate('/login', { replace: true });
      }
    })();
  }, []);
};

export default useVerifyWithTokenAndRedirect;
